<ng-container
  *ngIf="{
    report: report$ | async,
  } as content"
>
  @if (!content.report?.isLoading) {
    @if (!content.report?.hasError) {
      <div class="section-1">
        <div class="flex-col">
          <p class="section-title">{{ 'reports.creditSummary.title' | cxTranslate }}</p>

          <div class="mini-table m-t-20">
            <div class="mini-row">
              <div class="mini-col">
                <span class="title">{{ 'reports.creditSummary.paymentTerms' | cxTranslate }}</span>
              </div>

              <div class="mini-col">
                <span class="value">{{ content.report?.report?.paymentTerms }}</span>
              </div>
            </div>

            <div class="mini-row">
              <div class="mini-col">
                <span class="title">{{ 'reports.creditSummary.openInvoiceTotals' | cxTranslate }}</span>
              </div>

              <div class="mini-col">
                <span class="value">{{ content.report?.report?.openInvoicesTotal?.formattedValue }}</span>
              </div>
            </div>

            <div class="mini-row">
              <div class="mini-col">
                <span class="title">{{ 'reports.creditSummary.openOrderTotals' | cxTranslate }}</span>
              </div>

              <div class="mini-col">
                <span class="value">{{ content.report?.report?.openOrdersTotal?.formattedValue }}</span>
              </div>
            </div>

            <div class="mini-row">
              <div class="mini-col">
                <span class="title">{{ 'reports.creditSummary.avgPayDates' | cxTranslate }}</span>
              </div>

              <div class="mini-col">
                <span class="value">{{ content.report?.report?.averagePayDays }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="flex-col">
          <p class="section-title">{{ 'reports.creditSummary.accountPayable' | cxTranslate }}</p>

          <div class="mini-table m-t-20">
            <div class="mini-row">
              <div class="mini-col">
                <span class="title">{{ 'reports.creditSummary.current' | cxTranslate }}</span>
              </div>

              <div class="mini-col">
                <span class="value">{{ content.report?.report?.currentAmount?.formattedValue }}</span>
              </div>
            </div>

            <div class="mini-row">
              <div class="mini-col">
                <span class="title">{{ 'reports.creditSummary.pastDue1To30' | cxTranslate }}</span>
              </div>

              <div class="mini-col">
                <span class="value">{{ content.report?.report?.pastDueAmount1?.formattedValue }}</span>
              </div>
            </div>

            <div class="mini-row">
              <div class="mini-col">
                <span class="title">{{ 'reports.creditSummary.pastDue31To60' | cxTranslate }}</span>
              </div>

              <div class="mini-col">
                <span class="value">{{ content.report?.report?.pastDueAmount2?.formattedValue }}</span>
              </div>
            </div>

            <div class="mini-row">
              <div class="mini-col">
                <span class="title">{{ 'reports.creditSummary.pastDue61To90' | cxTranslate }}</span>
              </div>

              <div class="mini-col">
                <span class="value">{{ content.report?.report?.pastDueAmount3?.formattedValue }}</span>
              </div>
            </div>

            <div class="mini-row">
              <div class="mini-col">
                <span class="title">{{ 'reports.creditSummary.pastDue91To180' | cxTranslate }}</span>
              </div>

              <div class="mini-col">
                <span class="value">{{ content.report?.report?.pastDueAmount4?.formattedValue }}</span>
              </div>
            </div>

            <div class="mini-row">
              <div class="mini-col">
                <span class="title">{{ 'reports.creditSummary.pastDueOver180' | cxTranslate }}</span>
              </div>

              <div class="mini-col">
                <span class="value">{{ content.report?.report?.pastDueAmount5?.formattedValue }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section-2 m-t-20">
        <p class="section-title">{{ 'reports.creditSummary.currentInvoices' | cxTranslate }}</p>

        @if (content.report?.report?.invoices?.length) {
          <table-pro [configs]="tableConfig">
            <table datatable class="table-responsive table-md">
              <thead>
                <tr>
                  <th id="invoice">{{ 'reports.creditSummary.table.header.invoice' | cxTranslate }}</th>
                  <th id="invoiceDate">{{ 'reports.creditSummary.table.header.invoiceDate' | cxTranslate }}</th>
                  <th id="originalAmount">{{ 'reports.creditSummary.table.header.originalAmount' | cxTranslate }}</th>
                  <th id="amoutDue">{{ 'reports.creditSummary.table.header.amoutDue' | cxTranslate }}</th>
                  <th id="dueDate">{{ 'reports.creditSummary.table.header.dueDate' | cxTranslate }}</th>
                  <th id="pO">{{ 'reports.creditSummary.table.header.pO' | cxTranslate }}</th>
                  <th id="status">{{ 'reports.creditSummary.table.header.status' | cxTranslate }}</th>
                  <th id="creditAdjustments">{{ 'reports.creditSummary.table.header.creditAdjustments' | cxTranslate }}</th>
                  <th id="order">{{ 'reports.creditSummary.table.header.order' | cxTranslate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let _invoice of content.report?.report?.invoices">
                  <td [attr.data-value]="_invoice.invoiceId">
                    <span class="responsive-title">{{ 'reports.creditSummary.table.header.invoice' | cxTranslate }}: </span>

                    {{ _invoice.invoiceId }}
                  </td>

                  <td [attr.data-value]="_invoice.invoiceDate">
                    <span class="responsive-title">{{ 'reports.creditSummary.table.header.invoiceDate' | cxTranslate }}: </span>

                    {{ _invoice.invoiceDate | cxDate: 'MM/dd/yyyy' }}
                  </td>

                  <td [attr.data-value]="_invoice.total?.value">
                    <span class="responsive-title">{{ 'reports.creditSummary.table.header.originalAmount' | cxTranslate }}: </span>

                    {{ _invoice.total?.formattedValue }}
                  </td>

                  <td [attr.data-value]="_invoice.totalRemaining?.value">
                    <span class="responsive-title">{{ 'reports.creditSummary.table.header.amoutDue' | cxTranslate }}: </span>

                    {{ _invoice.totalRemaining?.formattedValue }}
                  </td>

                  <td [attr.data-value]="_invoice.dueDate">
                    <span class="responsive-title">{{ 'reports.creditSummary.table.header.dueDate' | cxTranslate }}: </span>

                    {{ _invoice.dueDate | cxDate: 'MM/dd/yyyy' }}
                  </td>

                  <td [attr.data-value]="_invoice.poNumber">
                    <span class="responsive-title">{{ 'reports.creditSummary.table.header.pO' | cxTranslate }}: </span>

                    {{ _invoice.poNumber }}
                  </td>

                  <td [attr.data-value]="_invoice.status">
                    <span class="responsive-title">{{ 'reports.creditSummary.table.header.status' | cxTranslate }}: </span>

                    {{ _invoice.status }}
                  </td>

                  <td [attr.data-value]="_invoice.adjustments?.value">
                    <span class="responsive-title">{{ 'reports.creditSummary.table.header.creditAdjustments' | cxTranslate }}: </span>

                    {{ _invoice.adjustments?.formattedValue }}
                  </td>

                  <td [attr.data-value]="_invoice.orderId">
                    <span class="responsive-title">{{ 'reports.creditSummary.table.header.order' | cxTranslate }}: </span>

                    {{ _invoice.orderId }}
                  </td>
                </tr>
              </tbody>
            </table>
          </table-pro>
        } @else {
          <p class="text-center">
            {{ 'reports.noContent' | cxTranslate }}
          </p>
        }
      </div>
    } @else {
      <alert [alert]="alertDanger"></alert>
    }
  } @else {
    <div class="m-t-20 m-b-4">
      <local-loader></local-loader>
    </div>
  }
</ng-container>